"use client";
import { useCallback, useEffect, useState } from "react";
/** Persisted UI state that must not flicker or leak between users. Never store secrets here. */
export function useLocalStorageState(key, fallback) {
    const [value, setValue] = useState(() => {
        if (typeof window === "undefined")
            return fallback;
        try {
            const raw = window.localStorage.getItem(key);
            return raw === null ? fallback : JSON.parse(raw);
        }
        catch {
            return fallback;
        }
    });
    useEffect(() => {
        try {
            window.localStorage.setItem(key, JSON.stringify(value));
        }
        catch {
            // Storage can be full or blocked; the UI must keep working regardless.
        }
    }, [key, value]);
    return [value, useCallback((next) => setValue(next), [])];
}
//# sourceMappingURL=use-local-storage-state.js.map